export const landAssetsStatusDataConstant =  [
  {
    land: 'Land A',
    date: '01/01/2023',
    userName: 'Topography A',
    size: '100',
    soilType: 'Clay',
    infrastructure: 'Available',
    zoning: 'Residential',
    heightLimit: '15m',
    density: 'Low',
  },
  {
    land: 'Land B',
    date: '02/02/2023',
    userName: 'Topography B',
    size: '150',
    soilType: 'Sandy',
    infrastructure: 'Not Available',
    zoning: 'Commercial',
    heightLimit: '30m',
    density: 'High',
  },
  {
    land: 'Land C',
    date: '03/03/2023',
    userName: 'Topography C',
    size: '200',
    soilType: 'Loam',
    infrastructure: 'Available',
    zoning: 'Industrial',
    heightLimit: '25m',
    density: 'Medium',
  },
  {
    land: 'Land D',
    date: '04/04/2023',
    userName: 'Topography D',
    size: '180',
    soilType: 'Peat',
    infrastructure: 'Available',
    zoning: 'Mixed-Use',
    heightLimit: '20m',
    density: 'High',
  },
  {
    land: 'Land D',
    date: '04/04/2023',
    userName: 'Topography D',
    size: '180',
    soilType: 'Peat',
    infrastructure: 'Available',
    zoning: 'Mixed-Use',
    heightLimit: '20m',
    density: 'High',
  },
  {
    land: 'Land D',
    date: '04/04/2023',
    userName: 'Topography D',
    size: '180',
    soilType: 'Peat',
    infrastructure: 'Available',
    zoning: 'Mixed-Use',
    heightLimit: '20m',
    density: 'High',
  },
  {
    land: 'Land D',
    date: '04/04/2023',
    userName: 'Topography D',
    size: '180',
    soilType: 'Peat',
    infrastructure: 'Available',
    zoning: 'Mixed-Use',
    heightLimit: '20m',
    density: 'High',
  },
  {
    land: 'Land D',
    date: '04/04/2023',
    userName: 'Topography D',
    size: '180',
    soilType: 'Peat',
    infrastructure: 'Available',
    zoning: 'Mixed-Use',
    heightLimit: '20m',
    density: 'High',
  },
]
